{
 "title": {
  "x": 306,
  "y": 682,
  "w": 332,
  "h": 38,
  "lane": {
   "x": 295,
   "y": 676,
   "w": 350,
   "h": 55
  }
 },
 "body1": {
  "x": 152,
  "y": 814,
  "w": 468,
  "h": 34,
  "lane": {
   "x": 148,
   "y": 806,
   "w": 648,
   "h": 44
  }
 },
 "body2": {
  "x": 157,
  "y": 855,
  "w": 628,
  "h": 33,
  "lane": {
   "x": 148,
   "y": 852,
   "w": 648,
   "h": 40
  }
 },
 "cta": {
  "x": 438,
  "y": 975,
  "w": 65,
  "h": 37,
  "lane": {
   "x": 300,
   "y": 966,
   "w": 340,
   "h": 58
  }
 }
}